<script setup lang="ts">
defineOptions({ inheritAttrs: false });
</script>
<template>
  <nut-cell v-bind="$attrs">
    <template #icon v-if="$slots.icon"><slot name="icon" /></template>
    <template #default v-if="$slots.default"> <slot name="default" /></template>
    <template #link v-if="$slots.link"><slot name="link" /></template>
    <template #title v-if="$slots.title"><slot name="title" /></template>
    <template #desc v-if="$slots.desc"><slot name="desc" /></template>
  </nut-cell>
</template>
